export const SWAP_NONE = 'SWAP_NONE'
export const SWAP_ERROR = 'ERROR'
export const SWAP_DISABLED = 'DISABLED'
export const SWAP_LOADING = 'LOADING'
export const SWAP_SUCCESS = 'SUCCESS'
